/** One-line captions under the page title in the app header (components/page-subtitles.ts). */
export const pageSubtitles: Record<string, string> = {
  'pageSub.dashboard': 'Phép, ngày công và chỉ số báo cáo của bạn',
  'pageSub.game': 'Mời trà, tích S-point, hiểu nhau hơn',
  'pageSub.marketing': 'Chi phí, doanh thu và lợi nhuận theo app và UA',
  'pageSub.appSpy': 'Tra cứu app và bảng xếp hạng cửa hàng',
  'pageSub.playableAds': 'Dựng và xuất quảng cáo playable',
  'pageSub.localize': 'Dịch video quảng cáo sang ngôn ngữ khác',
  'pageSub.competitor': 'Doanh thu AdMob và chi phí Google Ads',
  'pageSub.creativeSpy': 'Thư viện creative quảng cáo của đối thủ',
  'pageSub.campaignEditor': 'Sửa ngân sách chiến dịch Google Ads hàng loạt',
  'pageSub.monetization': 'Báo cáo doanh thu theo app và MO',
  'pageSub.ecpm': 'eCPM theo app, định dạng, ad unit và nguồn',
  'pageSub.admobMediation': 'Quản lý app, ad unit và mediation của AdMob',
  'pageSub.encrypt': 'Quản lý dự án, mã hoá và giải mã',
  'pageSub.appAssignment': 'Phân công người MO phụ trách từng app',
  'pageSub.moLead': 'Ad unit và mediation group của RoosterX',
  'pageSub.developer': 'Báo cáo doanh thu theo app và Dev',
  'pageSub.adsDecode': 'Giải mã thông tin trong file playable ad',
  'pageSub.issues': 'Chọn dự án để xem issue',
  'pageSub.myIssues': 'Issue được giao cho bạn hoặc do bạn báo',
  'pageSub.issuesAdmin': 'Thành viên và Discord webhook theo dự án',
  'pageSub.issuesReport': 'Lọc, thống kê và xuất CSV issue của mọi dự án',
  'pageSub.issueProject': 'Bảng, danh sách, backlog và timeline của dự án',
  'pageSub.issueDetail': 'Chi tiết một issue',
  'pageSub.docs': 'Tài liệu nội bộ theo dự án và toàn công ty',
  'pageSub.uaBotConsole': 'Theo dõi và điều khiển bot UA',
  'pageSub.asoTranslate': 'Dịch mô tả Play Store sang nhiều ngôn ngữ',
  'pageSub.firebaseRc': 'Xem và sửa Remote Config của Firebase',
  'pageSub.eventAnalytics': 'Số sự kiện GA4 theo app và theo ngày',
  'pageSub.siteContent': 'Nội dung website công ty và nội dung nội bộ',
  'pageSub.employees': 'Danh bạ, tổng quan và lương nhân viên',
  'pageSub.hrLeave': 'Số dư phép, đơn nghỉ và ngày lễ',
  'pageSub.hrConfig': 'Ngày làm việc, giờ làm và phép năm',
  'pageSub.hrLoginLogs': 'Lịch sử đăng nhập của nhân viên',
  'pageSub.products': 'Danh mục sản phẩm và lịch sử phân công UA',
  'pageSub.admin': 'Cài đặt hệ thống dành cho quản trị',
  'pageSub.okrAdmin': 'Chu kỳ, mục tiêu, KR và check-in OKR',
  'pageSub.licenses': 'Ai được dùng các extension nội bộ',
  'pageSub.commission': 'Hoa hồng theo tháng và theo năm',
  'pageSub.dividend': 'Tỷ lệ và số tiền cổ tức theo từng người',
  'pageSub.quiz': 'Tham gia ván Quiz đang diễn ra',
  'pageSub.quizHost': 'Điều khiển ván, lịch sử và quản lý quiz',
  'pageSub.teamVote': 'Các vòng bình chọn đang mở và đã đóng',
  'pageSub.examMy': 'Bài thi chưa làm, đang làm và đã xong',
  'pageSub.examTake': 'Mỗi màn một câu, có đồng hồ đếm ngược',
  'pageSub.examResult': 'Điểm hiện khi bài thi công bố kết quả',
  'pageSub.examTests': 'Tạo, mở, đóng và xem kết quả bài thi',
  'pageSub.examQuestions': 'Ngân hàng câu hỏi và nhập từ CSV',
  'pageSub.examCreate': 'Cơ bản, câu hỏi, lịch thi và chấm điểm',
  'pageSub.examGrade': 'Chọn bài thi, chọn bài làm rồi chấm',
  'pageSub.examResults': 'Xếp hạng, thống kê từng câu và xuất CSV',
  'pageSub.profile': 'Hồ sơ nhân viên và hoa hồng của bạn',
  'pageSub.leave': 'Xin nghỉ, số dư phép và lịch làm việc',
  'pageSub.handbook': 'Quy định chung của công ty để tra cứu',
  'pageSub.handbookStart': 'Đọc từng phần rồi xác nhận đã đọc',
  'pageSub.travelExpense': 'Quy định chi phí khi đi công tác',
  'pageSub.help': 'Hướng dẫn dùng từng công cụ',
};
